import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MetadataValue } from '../../models/metadataValue';
import { OutputParameterValue } from '../../models/moovStepInstance';

@Component({ standalone:false,
  selector: 'app-meta-data-dialog',
  templateUrl: 'meta-data-dialog.component.html',
  styleUrls: ['meta-data-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class MetaDataDialogComponent {
  title: string= "Custom field values";
  metaDataOutputList!: Array<OutputParameterValue[]>;
  confirmButtonText = "OK";
  
  private _dataSource!: MatTableDataSource<MetadataValue>;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<MetaDataDialogComponent>) {
    if(data){
        this.metaDataOutputList=data.metaDataOutputList;
        this.setDataSource();
    }
  }

  get displayedColumns() {
    return ['name', 'value'];
  }

  public setDataSource(){
    let metadataValues:MetadataValue[]=[];
    //get metadata from each md stepInstance
    this.metaDataOutputList.forEach(mdo=>{
      mdo.forEach(opv => {
        if(opv.stepType=='md' && opv.metadataValue) metadataValues.push(opv.metadataValue);
      })
    });
    this._dataSource=new MatTableDataSource(metadataValues);
  }

  get dataSource() {
    return this._dataSource;
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}